module.exports = __webpack_public_path__ + "img/banner3.14be5396.png";